import { FC, PropsWithChildren } from 'react';
import { Link } from '@/components/ui';
import { cn } from '@/utils';

type ProductCardNavigationWrapperProps = PropsWithChildren<{
  href: string;
  interactive: boolean;
  className?: string;
}>;

export const ProductCardNavigationWrapper: FC<ProductCardNavigationWrapperProps> = ({
  href,
  interactive,
  className,
  children,
}) => {
  if (!interactive) {
    return <div className={cn('h-full', className)}>{children}</div>;
  }

  return (
    <Link href={href} withoutLocale noStyle className={cn('block h-full', className)}>
      {children}
    </Link>
  );
};
